import { render, staticRenderFns } from "./access-point-table.vue?vue&type=template&id=2385729c&scoped=true&"
import script from "./access-point-table.vue?vue&type=script&lang=ts&"
export * from "./access-point-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2385729c",
  null
  
)

export default component.exports